"use client"

import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { useMediaQuery } from "@/hooks/useMediaQuery"
import { PropsWithChildren, useState } from "react"
import SupporterTable from "./SupporterTable"
import AvatarGroup from "@/app/components/Avatar/Group/AvatarGroup"
import { SupportersResp } from "@/types/coins"
import { User } from "@/types/users"

type Props = PropsWithChildren<{
  supportersWithAvatars: SupportersResp
  allSupporters: SupportersResp
  isSection?: boolean
  isNumbersOnly?: boolean
}>

export default function SupportersDialogDrawer({
  supportersWithAvatars,
  allSupporters,
  isSection,
}: Props) {
  const [open, setOpen] = useState(false)
  const isDesktop = useMediaQuery("(min-width: 640px)")

  const avatars = supportersWithAvatars.supporters
    .map((s): Partial<User> => {
      return {
        avatar_url: s.avatarUrl,
        lowercase_wallet_address: s.walletAddress as `0x${string}`,
        id: s.userId,
      }
    })
    .filter((_, i) => i < 3)
  const text = ""
  // TODO: Once we have Dune (or some other API) support total supporter counts, we can uncomment this to display that.
  // isSection
  //   ? `${allSupporters.totalSupporterCount}`
  //   : `${allSupporters.totalSupporterCount} supporters`
  const title = `${allSupporters.totalSupporterCount} supporters`

  if (allSupporters.totalSupporterCount === 0) return null

  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger className="flex items-center">
          <AvatarGroup
            avatars={avatars}
            text={text}
            textClassName="pointer-events-none truncate"
            small
          />
        </DialogTrigger>
        <DialogContent>
          <DialogHeader className="mb-2">
            <DialogTitle className="font-header text-foreground text-2xl">
              {title}
            </DialogTitle>
          </DialogHeader>
          <div className="max-h-[360px] overflow-auto">
            <SupporterTable supporters={allSupporters} />
          </div>
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger className="flex items-center">
        <AvatarGroup
          avatars={avatars}
          text={text}
          textClassName="pointer-events-none truncate"
        />
      </DrawerTrigger>
      <DrawerContent className="px-2">
        <DrawerHeader className="px-4 pt-4 pb-2">
          <DrawerTitle className="font-header text-foreground text-xl text-left">
            {title}
          </DrawerTitle>
        </DrawerHeader>
        <div className="max-h-[360px] mx-auto w-full">
          <SupporterTable isMinimal supporters={allSupporters} />
        </div>
      </DrawerContent>
    </Drawer>
  )
}
